import { JobService } from './JobService';
import { IJobService } from './IJobService';

export const jobService: IJobService = new JobService();
